export const PROVIDER_TYPES = {
  BUSINESS: 'business',
  INDIVIDUALS: 'individuals',
}

export const KNOWN_ERROR_MESSAGES = {
  invalid_postal_code: 'Invalid Postal Code',
}

export const DEFAULT_SEARCH_INFORMATION_STATE = {
  postalCode: '',
  radius: null,
  selectedLanguageId: null,
  invalidPostalCode: false,
}
